import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import Ajax from '../../lib/ajax';


class TransferModule extends ListModule<any, any, any>  {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<any>(),
    loading: false,
  };
  actions = {
    async getRegions() {
      // context.state.loading=true;
      let response = await Ajax.get(
        '/api/services/app/Transfer/GetRegions'
      );
      var data = response.data.result.items;
      return data;

    },

    async saveRegion() {

      let response = await Ajax.post('/api/services/app/Transfer/SaveRegion');

      var data = response.data.result.items;
      return data;
    },

  };

}
export default new TransferModule();
